export interface AnswerOption {
  label: string;
  value: any;
  description?: string;
}

export interface Question {
  type: QuestionType;
  title: string;
  description?: string;
  options?: AnswerOption[];
  altOption?: AnswerOption;
  reverse?: boolean;
}

export type QuestionType = "scale" | "radio" | "checkbox" | "none";

export enum DevelopmentType {
  Upskiller,
  Switcher,
}

export enum KnowingType {
  Know = "know",
  DontKnow = "dontknow",
}

export type Data = string | string[] | number;

export interface Questions {
  "2": Question;
  "3.1.1": Question;
  "3.1.2": Question;
  "3.1.3.1": Question;
  "3.1.3.2": Question;
  "3.2.1": Question;
  "4.1": Question;
  "4.2": Question;
  "4.3": Question;
  "4.4": Question;
  ict1: Question;
  ict2: Question;
  ict3: Question;
  zorg1: Question;
  zorg2: Question;
  zorg3: Question;
  creatief1: Question;
  creatief2: Question;
  creatief3: Question;
  techniek1: Question;
  techniek2: Question;
  techniek3: Question;
  onderwijs1: Question;
  onderwijs2: Question;
  onderwijs3: Question;
  "5"?: undefined;
}

export interface Answers {
  "2": Data;
  "3.1.1": undefined;
  "3.1.2": Data;
  "3.1.3.1": Data;
  "3.1.3.2": Data;
  "3.2.1": undefined;
  "4.1": undefined;
  "4.2": Data;
  "4.3": Data;
  "4.4": Data;
  ict1?: Data;
  ict2?: Data;
  ict3?: Data;
  zorg1?: Data;
  zorg2?: Data;
  zorg3?: Data;
  creatief1?: Data;
  creatief2?: Data;
  creatief3?: Data;
  techniek1?: Data;
  techniek2?: Data;
  techniek3?: Data;
  onderwijs1?: Data;
  onderwijs2?: Data;
  onderwijs3?: Data;
}
